import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_household_all: FaireCategoryEntity = {
  token: "cat_household-all",
  type: "category",
  name: "All household supplies & DIY",
  level: 3,
  parentToken: "cat_home-decor-household",
  href: "/category/home-decor/household-supplies-diy",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
